import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { IAllUsersDataEnt } from '../../users/allUsers/types';
import { ALL_USERS, EDIT_USERS } from './constants';
import {
  AllUsersSuccess,
  AllUsersError,
  AllUsersDataActionTypes,
  AllUsersAdministrationState,
  EditUsersAdministrationType,
} from './types';

const initialState: AllUsersAdministrationState = {
  status: idle,
  entities: null,
  error: null,
  pages: 0,
  count: 0,
};

export default produce(
  (
    draft = initialState,
    action: AllUsersDataActionTypes,
  ): AllUsersAdministrationState => {
    switch (action.type) {
      case ALL_USERS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_USERS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllUsersSuccess).payload.items;
        draft.pages = (action as AllUsersSuccess).payload.pages;
        draft.count = (action as AllUsersSuccess).payload.cnt;
        break;
      }
      case ALL_USERS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllUsersError).error;
        break;
      }
      case EDIT_USERS: {
        const newPayload = (action as EditUsersAdministrationType).payload;
        draft.entities = draft.entities.map((item: IAllUsersDataEnt) => {
          if (item.id === newPayload.id) {
            item = newPayload.user;
          }
          return item;
        });
        break;
      }
      default:
        return draft;
    }
  },
);
